import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { deadline: String };
  static targets = ["days", "hours", "minutes", "seconds"];

  connect() {
    this.deadline = new Date(this.deadlineValue);
    this.tick();
    this.interval = setInterval(() => this.tick(), 1000);
  }

  disconnect() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  tick() {
    const now = new Date();
    const diff = this.deadline - now;

    if (diff <= 0) {
      this.element.remove();
      clearInterval(this.interval);
      return;
    }

    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);

    this.daysTarget.textContent = String(days).padStart(2, "0");
    this.hoursTarget.textContent = String(hours).padStart(2, "0");
    this.minutesTarget.textContent = String(minutes).padStart(2, "0");
    this.secondsTarget.textContent = String(seconds).padStart(2, "0");
  }
}
